import { render, staticRenderFns } from "./TextWindow.vue?vue&type=template&id=706a6db0&"
import script from "./TextWindow.vue?vue&type=script&lang=js&"
export * from "./TextWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports